import { SpinnerIcon } from '../../../../../../../../../../../../../../../../../../shared/icons/spinner/spinner.icon'
import { SpinnerIconSize } from '../../../../../../../../../../../../../../../../../../shared/icons/spinner/types/spinner-size.icon.enum'
import { LoadingItemStyles } from './loading-item.styles'

export const LoadingItem = () => (
  <div className={LoadingItemStyles.item}>
    <SpinnerIcon size={SpinnerIconSize.SMALL} />
  </div>
)
